import React, { Component } from "react";
import { Button,Form,Icon,Grid } from "tabler-react";
import { GetRoles } from "../../herramientas/JWT";
import { Crud_Catalogos } from '../../herramientas/Crud_Catalogos';
class  ProveedoresForm extends Component {
  constructor(props) {
    super(props);
    this.state = {       nombre:      "",
                         url:         "",
                         puerto:      null,
                         username:    "",
                         password:    "",
                         accion: this.props.accion, //'nuevo'// modificar, nuevo
                         crudbutonEnable: true, // Se desabilita cuando se hace click
                  };
                  
    this.objeto={
        "nombre": "",
        "url": "",
        "puerto": null,
        "username": "",
        "password": ""
      };
  }
  componentDidMount =() => {
    if(this.state.accion !== 'nuevo'){
      this.setState({nombre: this.props.elemento.nombre});
      this.setState({url: this.props.elemento.url});
      this.setState({puerto: this.props.elemento.puerto});
      this.setState({username: this.props.elemento.username});
      this.setState({password: this.props.elemento.password});
      this.objeto= this.props.elemento;
    }
  }
  enableSave =() =>{
    if( this.state.nombre.length
        && this.state.url.length
        && this.state.puerto
        && this.state.username.length
        && this.state.password.length )
      return false;
    else
      return true
  }
  changeNombre =(event) => {
    this.setState({nombre: event.target.value});
    this.objeto.nombre= event.target.value;
  }
  changeUrl = (event) =>{
    this.setState({url: event.target.value});
    this.objeto.url= event.target.value;
  }
  changePuerto = (event) =>{
    this.setState({puerto: event.target.value});
    this.objeto.puerto= event.target.value;
  }
  changeUsername = (event) =>{
    this.setState({username: event.target.value});
    this.objeto.username= event.target.value;
  }
  changePassword = (event) =>{
    this.setState({password: event.target.value});
    this.objeto.password= event.target.value;
  }

  delete() {
    this.setState({ crudbutonEnable: false });
    Crud_Catalogos(this.props.catalogo, "delete", "", this.objeto.id).then((returnVal) => {
      window.location.reload();
    }).catch(err =>{ alert("A ocurrido un error")});
  }
  save(metodo= "post") {
    this.setState({ crudbutonEnable: false });
    Crud_Catalogos(this.props.catalogo, metodo, this.objeto, "").then((returnVal) => {
      //window.location.reload();
    }).catch(err =>{ alert("A ocurrido un error")});
  }
  
  passwordToX=()=>{
    let tempX= "";
    let temp= this.state.password;
    for (let index = 0; index < temp.length; index++) {
      tempX = tempX+"X";      
    }
    return tempX;
  }
  render(){
    return (
      <div>
        { this.state.accion === "modificar" ? <h1> { this.props.elemento.nombre } </h1> : null }
        <Grid.Row>
          <Grid.Col md={12} xl={12}>
            <Grid.Row>
              <Grid.Col md={9} lg={9}>
                <Form.Group label="Nombre">
                  <Form.Input name="nombre" type="text" value={ this.state.nombre } onChange={this.changeNombre} />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={6} lg={6}>
                <Form.Group label="Url">
                  <Form.Input name="url" type="text" value={ this.state.url } onChange={this.changeUrl} />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={6} lg={6}>
                <Form.Group label="Puerto">
                  <Form.Input name="puerto" type="number" value={ this.state.puerto } onChange={this.changePuerto} />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={6} lg={6}>
                <Form.Group label="Username">
                  <Form.Input name="username" type="text" value={ this.state.username } onChange={this.changeUsername} />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={6} lg={6}>
                <Form.Group label="Password">
                  <Form.Input name="password" type="password" value={ this.passwordToX() } onChange={this.changePassword} />
                </Form.Group>
              </Grid.Col>
            </Grid.Row>
          </Grid.Col>
        </Grid.Row>
        <div className="float-right">
          {GetRoles().includes("root") ?
            <span class="badge">
                <Button target="_blank" size="sm" RootComponent="a" color="primary" disabled= { this.enableSave() || !this.state.crudbutonEnable }
                  onClick= { this.state.accion === "modificar" ? () => this.save("put") : () => this.save("post") }
                >
                  <span class="badge"><Icon link={true} name="save" />Guardar</span>
                </Button>
            </span>
          :null}
          { GetRoles().includes("root")  ?
            <span class="badge">
              <Button target="_blank" size="sm" RootComponent="a" color="primary"
                onClick= { () => this.delete() } disabled={!this.state.crudbutonEnable}
              >
                <span class="badge"><Icon link={true} name="trash" />Borrar</span>
              </Button>
            </span>
          :
          null
          }
        </div>
      </div>
    );
  }
}
export default ProveedoresForm;
